import React from 'react';
import './Bubbles.css';
import PropTypes from 'prop-types';

const Bubbles = (props) => {
  const { colors } = props;
  const bg = { background: `${colors[0]}` };
  const arrayBubbles = Array(51).fill('bubble');

  return (
    <div className="bubbles-block" style={bg}>
      {arrayBubbles.map((item, index) => (
        <div className={item} key={index.toString()} />
      ))}
    </div>
  );
};

Bubbles.propTypes = {
  colors: PropTypes.array,
};

export default Bubbles;
